module.exports = __webpack_public_path__ + "static/media/boxingnews.8b7b3df2.jpg";